export const SubscriptionFeeMapper = (resp) => {
    var _a, _b;
    if (resp) {
        return {
            rateBased: (_a = resp.rateBased) === null || _a === void 0 ? void 0 : _a.map((x) => {
                return {
                    schemeRefNo: x.schemeRefNo,
                    schemeName: x.schemeName,
                    planType: x.planType,
                    startDate: x.startDate,
                    endDate: x.endDate,
                    chequeAmt: x.chequeAmt,
                    status: x.status,
                    consumed: x.consumed ? x.consumed : null,
                    balance: x.balance ? x.balance : null,
                };
            }),
            volBased: (_b = resp.volBased) === null || _b === void 0 ? void 0 : _b.map((x) => {
                return {
                    schemeRefNo: x.schemeRefNo,
                    schemeName: x.schemeName,
                    planType: x.planType,
                    startDate: x.startDate,
                    endDate: x.endDate,
                    chequeAmt: x.chequeAmt,
                    status: x.status,
                    allowed_Vol: x.allowed_Vol ? x.allowed_Vol : null,
                    balance_Vol: x.balance_Vol ? x.balance_Vol : null,
                    consumed_Vol: x.consumed_Vol ? x.consumed_Vol : null,
                };
            }),
        };
    }
    return { rateBased: [], volBased: [] };
};
